import React from "react";
import PartBoxplotPanel from "./PartBoxplotPanel";
import SectionLoader from "../general/component/loading";

export default function SectionBoxplot({
                                           jwtToken,
                                           boxplotForm,
                                           boxplotFormName,
                                           boxplotTargetOptions,
                                           boxplotFilterOptions,
                                           boxplotFilterValues,
                                           onFormChange,
                                           onAddFilterValue,
                                           onFormSubmit,
                                           boxplots,
                                           handleUpdate,
                                           showAlert,
                                           loading
}) {
    return (
        <section style={{ marginBottom: "40px" }}>
            <h2 style={{marginTop: "40px"}}>Boxplot</h2>
            <hr style={{marginTop:"0px"}}/>
            {/* form for creating new boxplot */}
            <div className="form-group" style={{width: "800px", marginBottom: "20px"}}>
                <form id="createBoxplot" onSubmit={onFormSubmit}>
                    <div className="form-group">
                        <label>Name</label>
                        <input style={{width: "220px"}}
                               className="form-control"
                               type="text"
                               name="name"
                               placeholder="boxplot name..."
                               value={boxplotFormName}
                               onChange={onFormChange}/>
                    </div>
                    <div className="form-group">
                        <label>Target Variable</label>
                        <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                            <select className="form-control"
                                    name="targetVariable"
                                    style={{width: "220px"}}
                                    value={boxplotForm.targetVariable}
                                    onChange={onFormChange}>
                                <option value="">---Select variable---</option>
                                {boxplotTargetOptions}
                            </select>
                            <select className="form-control"
                                    name="calculationMethod"
                                    style={{marginLeft:"20px", width: "220px"}}
                                    value={boxplotForm.calculationMethod}
                                    onChange={onFormChange}
                                    disabled={!boxplotForm.targetVariable}>
                                {boxplotForm.targetVariable ? (
                                    <>
                                        <option value="LOG_TRANSFORMATION">use Log transformation</option>
                                        <option value="NORMAL_DISTRIBUTION">use Normal distribution</option>
                                        <option value="BINOMIAL_DISTRIBUTION">use Binomial distribution</option>
                                    </>
                                ) : (
                                    <option value="">---computation method---</option>
                                )}
                            </select>
                        </div>
                    </div>
                    <div className="form-group">
                        <label>Filter Variable</label>
                        <div style={{display: "flex", flexDirection: "row", alignItems: "flex-start"}}>
                            <select className="form-control"
                                    name="filterVariable"
                                    style={{width: "220px"}}
                                    value={boxplotForm.filterVariable}
                                    onChange={onFormChange}>
                                <option value="">---Select variable---</option>
                                {boxplotFilterOptions}
                            </select>
                            <div style={{paddingLeft:"20px"}}>
                                {boxplotFilterValues}
                            </div>
                        </div>
                    </div>
                    <button type="submit"
                            style={{marginTop:"2px", paddingLeft:"30px", paddingRight:"30px"}}
                            className="btn btn-primary"
                            title="Create boxplot with applied parameters">CREATE</button>
                    <button style={{marginTop:"2px", paddingLeft:"30px", paddingRight:"30px", marginLeft: "10px"}}
                            className="btn btn-default"
                            onClick={onAddFilterValue}
                            title="Add filter variable value">ADD FILTER VALUE</button>
                </form>
            </div>
            {/* render all boxplots */}
            {loading ? (
                <SectionLoader />
            ) : boxplots && boxplots.length > 0 ? (
                boxplots.map((boxplot, index) => (
                    <PartBoxplotPanel
                        key={boxplot.id}
                        jwtToken={jwtToken}
                        boxplotIndex={index}
                        boxplotData={boxplot}
                        handleUpdate={handleUpdate}
                        showAlert={showAlert}
                    />
                ))
            ) : (
                <div className="alert alert-warning" style={{ textAlign: "center" }}>
                    <strong>No Boxplots created.</strong>
                </div>
            )}
        </section>
    );
}
